import store from '@/store';
import {
  Action,
  Module,
  Mutation,
  VuexModule,
  getModule
} from 'vuex-module-decorators';

import {
  fetchTenantInfoLite
} from '../api';

import {
  TenantLite
} from '../models';

@Module({
  dynamic: true,
  namespaced: true,
  name: 'tenantModule',
  store
})
class TenantModule extends VuexModule {
  public tenantInfoLite: TenantLite | null = null;

  @Mutation
  public setTenantInfoLite(tenantInfoLite: TenantLite) {
    this.tenantInfoLite = tenantInfoLite;
  }

  @Action({ commit: 'setTenantInfoLite' })
  public resetTenantInfoLite() {
    return null;
  }


  @Action({ commit: 'setTenantInfoLite', rawError: true })
  public async loadTenantInfoLite(languageCode?: string) {
    try {
      if (this.tenantInfoLite) {
        return this.tenantInfoLite;
      }
      const tenant = await fetchTenantInfoLite(languageCode);
      return tenant;
    } catch (error) {
      throw new Error(error as string);
    }
  }

}

export default getModule(TenantModule);
